import styled, { css } from "styled-components";
import { ToastStatus } from "hooks/toast";

interface ToastProps {
  type: ToastStatus;
  isVisible: boolean;
}

export const ToastContainer = styled.div<ToastProps>`
  ${({ theme, isVisible, type }) => css`
    position: relative;
    display: flex;
    min-height: 70px;
    width: 100%;
    min-width: 305px;
    max-width: 350px;
    align-items: center;
    gap: 12px;
    padding: 10px;
    border: 1px solid;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    background-color: ${theme.colors.menu_detail_light};
    transition: all 300ms ease-in-out;
    opacity: ${isVisible ? 1 : 0};
    transform: translateX(${isVisible ? 0 : 100}px);

    ${type === "success" &&
    css`
      border-color: ${theme.colors.primary_medium};
    `}

    ${type === "error" &&
    css`
      border-color: ${theme.colors.feedback_error};
    `}

    ${type === "info" &&
    css`
      border-color: ${theme.colors.feedback_info};
    `}

    ${type === "warning" &&
    css`
      border-color: ${theme.colors.feedback_warning};
    `}
  `};
`;

export const ToastIcon = styled.div`
`;

export const ToastContent = styled.div`
  flex: 1;
`;

export const ToastTitle = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.bold};
    color: ${theme.colors.text_extra_light};
  `}
`;

export const ToastDescription = styled.div`
  ${({ theme }) => css`
    font-size: 12px;
    color: ${theme.colors.text_light_87};
    margin-top: 6px;
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 8px;
  top: 4px;
  padding: 2px;

  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    cursor: pointer;
  }
`;
